import { PatientMedication } from '../../../schemas/ehr/ehr-state/medication.mjs';
import type { Allergy } from '../../../schemas/ehr/ehr-state/allergy.mjs';
import type { PatientDiagnosis } from '../../../schemas/ehr/ehr-state/diagnosis.mjs';
import { LabResult } from '../../../schemas/ehr/ehr-state/labResults.mjs';
import { PaginationInput, PaginationResponse } from '../../../schemas/ehr/ehr-state/pagination.mjs';
import { Vitals } from '../../../schemas/ehr/ehr-state/vitals.mjs';

export enum PatientEnhancements {
  GET_PROBLEM_LIST = 'getProblemList',
  GET_MEDICATION_LIST = 'getMedicationList',
  GET_ALLERGY_LIST = 'getAllergyList',
  GET_LAB_RESULTS = 'getLabResults',
  GET_VITALS = 'getVitals',
}

export type PatientEnhancementsAPI = {
  getProblemList(): Promise<PatientDiagnosis[] | undefined>;
  getMedicationList(): Promise<PatientMedication[] | undefined>;
  getAllergyList(): Promise<Allergy[] | undefined>;
  getLabResults(
    input: PaginationInput,
  ): Promise<{ items: LabResult[]; pagination: PaginationResponse } | undefined>;
  getVitals(
    input: PaginationInput,
  ): Promise<{ items: Vitals[]; pagination: PaginationResponse } | undefined>;
};

/**
 * THIS Types below are used to verify that the PatientEnhancementsAPI
 * uses all the properties from the enum & the other way around
 *
 * The reason is using mapped types "[PatientEnhancements.GET_PROBLEM_LIST]()" instead of "getProblemList()"
 * creates bad autocomplete typings
 */
type KeysOfAPI = {
  [x in keyof PatientEnhancementsAPI]: any;
};
type KeysOfEnum = {
  [x in PatientEnhancements]: any;
};
const enumObj: KeysOfEnum = {} as any;
const apiObj: KeysOfAPI = {} as any;

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const assertOneWay = enumObj satisfies KeysOfAPI;
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const assertOtherWay = apiObj satisfies KeysOfEnum;
